<!--
 * @Description: 
 * @Autor: tanglitong
 * @Date: 2022-05-05 14:24:43
 * @LastEditors: tanglitong
 * @LastEditTime: 2022-06-29 14:42:11
-->
<template>
  <div>
    <div class="video_top">
      <div class="vt">
        <div class="vt_logo">
          <a href="/">
            <img alt="" src="../assets/img/shiyan_logo.jpg"/>
          </a>
        </div>
        <div v-if="!publicCourse" class="vt_nav">
          <a
            v-if="trainingInfo.practiseSwitch === 0"
            class="vtn_wyks"
            href="javascript:"
            style="background: #C7C7C7"
          ><span></span>{{ isCme ? '我要考试' : '我要练习' }}</a>
          <a
            v-else-if="practice.length === 0"
            class="vtn_wyks"
            href="javascript:"
            style="background: #C7C7C7"
          ><span></span>{{ isCme ? '我要考试' : '我要练习' }}</a>
          <!-- <a href="javascript:;" class="vtn_wyks" v-else @click="toPractice()"
            ><span></span>{{ isCme ? "我要考试" : "我要练习" }}</a
          > -->
          <a v-else class="vtn_wyks" href="javascript:" @click="handleCourse('toPractice')"
          ><span></span>{{ isCme ? '我要考试' : '我要练习' }}</a>
          <a
            v-if="handoutUrl == ''"
            class="vtn_jy"
            href="javascript:"
            style="background: #C7C7C7"
          ><span></span>讲&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;义</a>
          <a v-else class="vtn_jy" href="javascript:" @click="handleCourse('openPdf')"
          ><span></span>讲&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;义</a>
          <a
            class="vtn_xxmb"
            href="javascript:"
            @click="objectiveVisible = true;plyrInstances.pause();"
          ><span></span>学习目标</a>
          <a
            class="vtn_lsjj"
            href="javascript:"
            @click="teachInfoVisible = true;plyrInstance.pause();"
          ><span></span>老师简介</a>
        </div>
      </div>
    </div>
    <!--视频播放-->
    <div
      v-loading="videoLoading"
      class="video_main"
      element-loading-text="正在初始化播放器..."
    >
      <div class="vm">
        <!--视频模块-->
        <div class="vm_video">
          <video id="video_id" ref="video" controls crossorigin></video>
        </div>
        <!--视频目录-->
        <div class="vm_list">
          <div :title="courseName" class="vml_title">
            {{ courseName }}
          </div>
          <div class="vml_main">
            <ul>
              <li
                v-for="(item, index) in courseVideoArr"
                :key="item.id"
                :class="{vmlm_ing: defaultActive == index + 1}"
                @click="handleSelect(index + 1,'changevideo');fullScreenDel();"
              >
                <span>
	                <img :src="item.posterUrl" alt=""/>
                  <p>{{ formatTime(item.videoTotalTime) }}</p>
                </span>
                <a href="javascript:">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="vm_star">
          <span class="vms_title">我要评分：</span>
          <div class="vms_pf">
            <el-tooltip placement="top">
              <div slot="content">
                {{ isUserRate ? '我的评星' : '单击提交评星' }}：
                <el-rate
                  v-model="userRate"
                  :disabled="isUserRate"
                  :texts="['1分', '2分', '3分', '4分', '5分']"
                  show-text
                  text-color="#ff9900"
                  @change="rateChange"
                ></el-rate>
              </div>
              <el-rate
                v-model="rateValue"
                :texts="['1分', '2分', '3分', '4分', '5分']"
                disabled
                show-text
                text-color="#ff9900"
              ></el-rate>
            </el-tooltip>
          </div>
          
          <div v-show=" traningInfo.enableProgressShow == 1 " class="video_dabiao">
            视频达标要求：{{ trainingInfo.electiveRatio }}% &nbsp;&nbsp;&nbsp;&nbsp;
            已完成 ：{{ percent }}%
          </div>
          <div class="vm_qingxi">
            <el-tooltip placement="top">
              <div slot="content">
                标清：标准清晰度，适合网络条件好的情况，视频质量以及清晰度更高。
                <br/>
                普清：普通清晰度，如果标清播放卡顿可以尝试切换此模式，视频质量相对低，但是播放会更流畅。
              </div>
              <el-switch
                v-model="playModeValue"
                active-color="#13ce66"
                active-text="标清"
                allow-half
                inactive-color="#ff4949"
                inactive-text="普清"
                @change="playModeChange"
              >
              </el-switch>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    
    <!--评论-->
    <div style="width:100%;height:100%;background:#ffffff;">
    <comment :typeId="'1_' + $route.query.cId" class="video_comment"></comment>
    </div>
    <footer1></footer1>
    
    <template>
      <el-dialog :visible.sync="teachInfoVisible" title="老师简介" width="50%">
        <div class="mt_main pl165 yh">
          <div class="mtm_left">
            <img :src="teachInfo && teachInfo.photo" height="185" width="150"/>
          </div>
          <div class="mtm_right">
            <p>{{ teachInfo && teachInfo.nickName }}</p>
            <p>{{ teachInfo && teachInfo.about }}</p>
          </div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="objectiveVisible" title="学习目标" width="50%">
        <div class="mt_main">
          <p>&nbsp;&nbsp;&nbsp;&nbsp;{{ objective }}</p>
        </div>
      </el-dialog>
      <loginLayer :visible.sync="loginVisible"></loginLayer>
    </template>
    
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="dialogVisible"
      title="练习"
      width="30%"
    >
      <span>{{ practiseData.stem }}</span
      ><br/><br/>
      <el-radio-group v-model="practiseAns">
        <el-radio
          v-for="item in practiseData.opts"
          :key="item.id"
          :label="item.opt"
          style="display: block; white-space: nowrap; margin-left: 0"
        >{{ item.opt + ' ' + item.ctnt }}
        </el-radio>
      </el-radio-group>
      <br/>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAnswer"
        >确&nbsp;&nbsp;&nbsp;定</el-button
        >
      </span>
    </el-dialog>
    <!-- 人脸识别弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="faceRecognitionDialogVisible"
      center
      class="face_recognition"
      width="600px"
    >
      <template>
        <div slot="title">
          <h5 style="font-size: 18px">请先进行人脸识别</h5>
        </div>
      </template>
      <div
        v-if="faceRecognitionDialogVisible"
        class="fr_content"
        style="text-align: center"
      >
        <vue-qr :size="250" :text="faceRecognitionQR"></vue-qr>
        <p>
          请使用<span>医博士APP</span>扫码，进行人脸识别。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="faceRecognitionDialogVisible = false"
        >取消</el-button
        >
        <el-button type="primary" @click="isFaceVerification()"
        >已完成识别</el-button
        >
      </span>
    </el-dialog>
    <!-- 学习弹窗 -->
    <el-dialog
      :center="true"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="toWriteQuestionVisible"
      title="温馨提示"
      top="30vh"
      width="380px"
    >
      <span>视频课程已学习完毕，是否直接进入{{ isCme ? '【我要考试】' : '【我要练习】' }}？</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-right: 60px; padding-left: 30px; padding-right: 30px"
          @click="toWriteQuestionVisible = false;toWriteQuestionVisibleIsFirst = false;"
        >否</el-button>
        <el-button style="padding-left: 30px; padding-right: 30px" type="primary"
          @click="handleCourse('dialogToPractice')"
        >是</el-button>
      </span>
    </el-dialog>
    <el-dialog :center="true" :close-on-click-modal="false" :show-close="false" :visible.sync="showtipdrag"
          title="温馨提示" top="30vh" width="480px">
          <span>亲爱的学员，根据学习过程管理要求，首次观看课件时不能拖拽， 需按课件顺序依次学习，祝您学有所获，辛苦了!</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showtipdrag = false;disabledDrag=false" type="primary">知道了</el-button>
          </span>
    </el-dialog>  
  </div>
</template>

<script>
import {
  getCourseWareByCourse,
  getFaceResult,
  getFaceSecretKey,
  getTrainingById,
  getUserCoursePercent,
  getVideoRecords,
  postVideoCheckOnlineStudy,
  saveCourseRate,
  saveVideoRecord,
  saveWatchRecords,
  syncCourseStatus,
  trainingSignIn,
  getUserCoursePercentv2,
  syncCourseStatusV2,
  queryCoursePracticesnew
} from '@/api/api_new'
import comment from '../components/Comment'
import loginLayer from '../components/LoginLayer'
import footer1 from '../components/Footer1'
// @ts-ignore
import { plyr } from 'plyr';
import 'plyr/dist/plyr.css'
import jsonp from 'jsonp'
import { mapGetters } from 'vuex'
import util from '../common/js/util'
import { CloseWebPage } from '@/utils/global-methods'
//import DialogScoreBuyShop from '../components/DialogScoreBuyShop'
//import DialogScoreBuyShopCallback from '../components/DialogScoreBuyShopCallback'
import { VerifyDeviceBinding, VerifyDeviceBindingOpt } from '@/utils/fingerprint'
//import vueQr from 'vue-qr'
import debounce from 'lodash/debounce'
import ChangePassword from '@/components/ChangePassword/index.vue'
import {
    createUuid
} from '../utils/global-methods'


export default {
  components: {
    ChangePassword,
    loginLayer,
    comment,
    footer1,
    //DialogScoreBuyShop,
    //DialogScoreBuyShopCallback,
    //vueQr,
  },
  data() {
    return {
      playModeValue: this.$storejs.get('playModeValue') == false ? false : true,
      plyrInstances: null,
      isCme: false,
      defaultActive:1,
      courseName: '',
      courseVideoArr: [],
      courseVideoArrId: null, //视频id
      courseVideoArrTotalTime:0,//当前视频总时间时间
      objective: '',
      objectiveVisible: false,
      teachInfo: {},
      teachInfoVisible: false,
      handoutUrl: '',
      courseFieldID: '',
      practice: [],
      toWriteQuestionVisible: false, //去练习开始弹窗
      toWriteQuestionVisibleIsFirst: true, //去练习开始弹窗是不是初次
      practiseSwitch: 0,
      traningInfo: {}, //培训班详情信息
      dialogVisible: false,
      practiseData: {},
      practiseAns: '',
      watchTime: 0,
      watchTimeVideo: 0,
      watchTimeVideoLock: 0,
      updWatchTime: 0,
      updWatchTimeVideo: 0,
      updWatchTimeVideoLock: 0,
      publicCourse: !(
        this.$route.query.uId &&
        this.$route.query.tId &&
        this.$route.query.pId
      ),
      palyerRecord: [],
      setT: null,
      setTVideo: null,
      setTVideoLock: null,
      seekTime: 0,
      rateValue: 5,
      isUserRate: false,
      userRate: 0,
      loginVisible: false,
      videoLoading: true,
      trainingInfo: {},
      viewCourseTime: 0,
      viewCourseTimeVideo: 0,
      courseCountTime: 0,
      percent: 0,
      isEnded: true,
      scoreBuyShopDialogShow: false,
      trainingId: this.$route.query.tId,
      showorNotParams: '',
      showAds: '0',
      videoHistorylist: null, //视频播放记录数组
      loadedmetadataLock: true, //是否可以获取视频进度接口
      saveVideoRecordLock: true,
      retry: 1, //可重试发送次数
      faceRecognitionDialogVisible: false, //人脸识别二维码弹窗
      faceRecognitionQR: '', //生成二维码信息
      faceRecognitionUuid: '', //生成的UUID信息
      handleType: '', //操作类型
      implementAutoProgress: false, //是否执行过自动视频进度
      initVideoConfig: {
        blankUrl: 'http://source.yiboshi.com/plyr/blank.mp4',
        settings: [
          'speed'
        ],
        speed: {
          selected: 1,
          options: [1]
        },
        i18n: {
          speed: '倍速',
          normal: '正常'
        },
         loadSprite: true,
         iconUrl:`/static/sprite.svg`
      },
      studySignTimer: null, //学习签到定时器
      studySignInterval: 60 * 15, //弹出继续学习确认时间间隔
      studySignNum: 0, //学习签到倒计时
      trainingEnd: false, //培训班已结束状态
      tryVideoInfo: {
        courseVideoArr: [],
        tryWatchTime: null
      }, //视频试看结束时间
      tryVideoEnd: {
        activeEnd: null,
        timeEnd: null
      },
      changePasswordShow: false,
      coursePercentV2:[],//视频观看信息
      onceenter:false,//刷新或者初次进来标志，用于调用第一次上传记录，判断是否但设备登录
      showtipdrag:false,//显示禁止拖拽提示
      changeflag:'',//是否允许切换视频
      defaultvideo:-1,//页面首次进来播放的视频key
      uuid:'',
      errorflag:0,//异常标识
      disabledDrag:false,//true,禁止拖拽
      disablesave:false,//禁止上传记录
      watchTimeErrorList:[],
      setErrorList:null,
      oldplaybackRate:1,//上次倍速
      isFloatAccountSHow:false,//国家继教绑定弹窗
      isNobindShow:false,//悬浮重新选择提示
      uploadTime: false,
      isUploadError: false,//正常上传进入错误池标识
      hasShownSpeedWarning: 0,//是否显示非法倍速警告
    }
  },
  watch: {
    watchTime: function (val) {
      if ((val>0&&val % 40 == 0)) {
        // this.syncWatchTime()
        //  console.log(new Date().toLocaleString(), 'watchTime')
         this.syncWatchTimev2(1)
      }
    },
    //视频播放进度计时保存
    watchTimeVideo: function (val) {
      if (val % 50 == 0) {
        // this.saveVideoRecord()
      }
    },
    //视频上传失败的记录
    watchTimeErrorList:function(val){
      console.log('val',val.length)
       if (val.length) {
          // console.log(val, 'watchTimeErrorList')
        if(this.setErrorList){
           this.setErrorList = window.clearInterval(this.setErrorList)
        }
        this.setErrorList=setInterval(()=>{
           this.saveRecordError(0)
        },5000)
      }else{
        this.isUploadError = false
        if (this.setErrorList) {
           this.setErrorList = window.clearInterval(this.setErrorList)
         }
      }
    },
    //视频播放锁定计时保存 //合并成上传记录接口
    watchTimeVideoLock: function (val) {
      if (val % 30 == 0) {
        // this.postVideoCheckOnlineStudy(1)
      }
    },
    videoHistorylist: function (val) {
      if (val.length > 0) {
        this.getVideoHistory(this.courseVideoArr, val[0].coursewareId)
      }
    },
    /**
     * @description: 视频列表
     */
    courseVideoArr: {
      handler(val) {
        if (val.length > 0) {
          // 保证视频试看计算时已有视频列表数据
          this.tryVideoInfo.courseVideoArr = val
        }
      },
      deep: true
    },
    /**
     * @description: 视频试看总时间
     */
    'traningInfo.tryWatchTime': {
      handler(val) {
        if (val) {
          // 保证视频试看计算时已有总时间(秒)
          this.tryVideoInfo.tryWatchTime = Math.round(val * 60)
        }
      },
      deep: true
    },
    /**
     * @description: 视频试看总时间
     */
    tryVideoInfo: {
      handler(val) {
        if (val.courseVideoArr.length > 0 && val.tryWatchTime) {
          let total = 0
          // 计算试看结束的章节和时间
          for (let i = 0; i < val.courseVideoArr.length; i++) {
            const v = val.courseVideoArr[i]
            if (total + Number(v.videoTotalTime) < val.tryWatchTime) {
              total += Number(v.videoTotalTime)
            } else {
              this.tryVideoEnd.activeEnd = i + 1
              this.tryVideoEnd.timeEnd = val.tryWatchTime - total
              break
            }
          }
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  beforeDestroy() {
    this.pauseVideo()
  },
  destroyed() {
    //移除beforeunload
    window.removeEventListener('beforeunload', this.pauseVideo)
  },
  async mounted() {
   
    //刷新页面清楚页面缓存的最大观看位置，与进度条时间一致，解决用户刷新之后，由于未上传记录，本地缓存的最大观看位置时间未上传至后台，导致用户未上传uptime学习时间，却更新了最大位置，
    const keys= Object.keys(sessionStorage)
    const result=keys.filter(item=>item.includes('maxtime'))
    for(const item of result){
      sessionStorage.setItem(item,'')
    }
    if(sessionStorage.getItem('tabuuid')){
       this.uuid= sessionStorage.getItem('tabuuid')
    }else{
       this.uuid = createUuid()
       sessionStorage.setItem('tabuuid',this.uuid)
    }
    this.weakPasswordDetection()
    localStorage.removeItem('plyr') // 清除播放器设置缓存
    //注册beforeunload
    window.addEventListener('beforeunload', this.pauseVideo)
    
    this.showAds = this.$route.query.showAds
    if (!this.publicCourse) {
      const trainInfo = await this.getTrainingById() //根据培训班id获取培训班
     this.coursePercentV2= await this.getUserCoursePercentV2()//获得课程视频观看完成度v2
      if (trainInfo.status === 200) {
        this.traningInfo = trainInfo.data.training
      }
      if (trainInfo.status === 200) {
        this.bangDingCard(trainInfo.data.training) //判断是否 是在学习之前 是否绑卡
        if (trainInfo.data.training.enableChangeSpeed === 1) { //开启倍速
          this.initVideoConfig.speed.options = [0.75, 1, 1.2, 1.5, 2]
        }
      }
      this.plyrInstances = new Plyr(this.$refs.video,this.initVideoConfig)
      this.initPlayerEvents() //初始化播放器监听事件
      this.refreshPalyerRecord()
      this.getCourseWareByCourse() //获得课件
      // this.getUserCoursePercent() //获得课程视频观看完成度
      // this.onceenter=true
     
    } else {
      this.plyrInstances = new Plyr(this.$refs.video,this.initVideoConfig)
      this.initPlayerEvents() //初始化播放器监听事件
      this.getCourseWareByCourse() //获得课件
    }
    // this.saveWatchRecords()
  },
  methods: {
  
    /**
   * @description: 获取当前视频的最大观看时长,观看位置
   */
    getMTime(){
       const uId = this.$route.query.uId
      const tId = this.$route.query.tId
      const pId = this.$route.query.pId
      const cId = this.$route.query.cId
      const currenttime= parseFloat(sessionStorage.getItem(`${uId}_${tId}_${pId}_${cId}_${this.courseVideoArrId}_currentTime`))||0//当前视频观看位置
     //init时接口获取当前视频观看的最大时长
      const maxtimejiekou=this.coursePercentV2.coursewareList.find((item) => {
        if(item.coursewareId == this.courseVideoArrId){}
        return item.coursewareId == this.courseVideoArrId
      }).viewTime
     //本地缓存最大时长
     const maxtimecache= Number(sessionStorage.getItem(`${uId}_${tId}_${pId}_${cId}_${this.courseVideoArrId}_maxtime`))||0
    //  console.log( currenttime, maxtimejiekou, maxtimecache,'接口---')
      const time={
        currentLocationTime: currenttime,
        maxLocationTime: Math.max(currenttime, maxtimejiekou, maxtimecache)
      }
      // console.log(time,'time')
      return time
    },
    /**
     * @description: 视频禁止拖动
     */
    videoProhibitDragging(){
      const progress = document.querySelector('.plyr__progress')
      // 鼠标松开事件,timout捕捉进度条时间
      progress.addEventListener('mousedown', (event) => {
        // console.log('mousedown');
        const maxAllowedTime = this.getMTime().maxLocationTime
        this.disablesave=true
        // this.plyrInstances.pause()
        // console.log(event.which,'event.whichmousedown')
        setTimeout(() => {
          if (event.which === 1) {
            const media = this.plyrInstances.media;
            // console.log(media.currentTime, maxAllowedTime,'000000000')
            if (media.currentTime > maxAllowedTime) {
              this.plyrInstances.media.currentTime = maxAllowedTime
              if(this.plyrInstances.fullscreen.active){
                this.plyrInstances.fullscreen.exit()
              }
              this.showtipdrag=true
              this.disabledDrag = true
              this.disablesave = false
              this.plyrInstances.pause()
            }else{
               this.disablesave = false
              // this.plyrInstances.play()
            }
          }
        }, 0);
      });
      // 鼠标移动事件
    progress.addEventListener('mousemove',(event) => {
        const maxAllowedTime = this.getMTime().maxLocationTime
        setTimeout(()=>{
        const media = JSON.parse(this.plyrInstances.media.currentTime);
        if(event.which === 1) {
         if (parseFloat(media) >maxAllowedTime) {
             this.plyrInstances.media.currentTime = maxAllowedTime
            event.preventDefault();
          if (this.plyrInstances.fullscreen.active) {
             this.plyrInstances.fullscreen.exit()
           }
            this.showtipdrag = true
             this.disabledDrag = true
            // this.plyrInstances.pause()
          }
        }
         }, 0)
      })
    document.addEventListener('keydown', (event) => {
      const maxAllowedTime = this.getMTime().maxLocationTime
        // this.disablesave = true
      //  this.plyrInstances.pause()
      //  console.log(event.keyCode, 'event.keyCodekeydown')
       setTimeout(() => {
         if (event.keyCode === 39) {
           const media = this.plyrInstances.media;
          //  console.log(media.currentTime, maxAllowedTime, '000000000')
           if (media.currentTime > maxAllowedTime) {
             this.plyrInstances.media.currentTime = maxAllowedTime
             if (this.plyrInstances.fullscreen.active) {
               this.plyrInstances.fullscreen.exit()
             }
               this.plyrInstances.pause()
             this.showtipdrag = true
             this.disabledDrag = true
            // this.disablesave = false
           }
         }
       }, 0);
      })
     
    },
    /**
     * @description: 首页初始化进行弱密码检测
     */
    weakPasswordDetection() {
      const token = localStorage.getItem(`${ process.env.VUE_APP_APPKEY }token`)
      if (!this.userInfo || !token) return
      const pwWeak = localStorage.getItem(`${ this.userInfo.uuid }_pw_weak`)
      // 已经登录并且有弱密码标记的进如修改密码步骤
      if (pwWeak) {
        this.changePasswordShow = true
      }
    },
    /**
     * @description: 试看视频
     */
    tryVideo() {
      // 未绑卡并且开启了视频试看
      if (this.traningInfo.isBandCard === 0 && this.traningInfo.creditBingdingTerm === 5) {
        if (this.defaultActive > this.tryVideoEnd.activeEnd) {
          this.videoTrialPlayingDel()
          this.videoTrialEndAdd()
          this.pauseVideo() //暂停播放
        } else if (this.defaultActive === this.tryVideoEnd.activeEnd) {
          if (this.plyrInstances.currentTime >= this.tryVideoEnd.timeEnd) {
            this.pauseVideo() //暂停播放
            this.videoTrialPlayingDel()
            this.videoTrialEndAdd()
          } else {
            this.videoTrialEndDel()
            this.videoTrialPlayingAdd()
          }
        } else {
          this.videoTrialEndDel()
          this.videoTrialPlayingAdd()
        }
      }
    },
    /**
     * @description: 播放中试看购买添加
     */
    videoTrialPlayingAdd() {
      let video_trial_playing_html = document.querySelector('.video_trial_playing')
      if (video_trial_playing_html) return
      const that = this
      let html = `<div class="video_trial_playing">
				<span>本课程可试看${ this.trainingInfo.tryWatchTime }分钟，购买后可观看完整内容</span>
				<a class="buyVideo">去购买</a>
			</div>`
      let plyr_html = document.querySelector('.plyr') //播放器窗口
      plyr_html.insertAdjacentHTML('beforeend', html)
      let buy_video_html = document.querySelector('.plyr .video_trial_playing .buyVideo') //去购买
      buy_video_html.onclick = function () {
        that.scoreBuyShopDialogShow = true
        that.showorNotParams = 'VideoTrial'
        that.pauseVideo() //暂停播放
        that.plyrInstances.fullscreen.exit()
      }
    },
    /**
     * @description: 播放中试看购买删除
     */
    videoTrialPlayingDel() {
      let video_trial_playing_html = document.querySelector('.video_trial_playing')
      if (video_trial_playing_html) {
        let plyr_html = document.querySelector('.plyr')
        plyr_html.removeChild(video_trial_playing_html)
      }
    },
    /**
     * @description: 播放结束试看购买添加
     */
    videoTrialEndAdd() {
      let video_trial_end_html = document.querySelector('.video_trial_end')
      if (video_trial_end_html) return
      this.pauseVideo() //暂停播放
      const that = this
      const shoppingCartImg = require('@/assets/images/shopping-cart.png')
      const refreshImg = require('@/assets/images/refresh.png')
      let html = `<div class="video_trial_end">
				<span>试看结束，购买后可观看完整版</span>
				<button><img src="${ shoppingCartImg }" alt=""/>去购买</button>
				<p><img src="${ refreshImg }" alt=""/>重新试看</p>
			</div>`
      let plyr_html = document.querySelector('.plyr') //播放器窗口
      plyr_html.insertAdjacentHTML('beforeend', html)
      let buy_video_html = document.querySelector('.plyr .video_trial_end >button') //去购买
      buy_video_html.onclick = function () {
        that.scoreBuyShopDialogShow = true
        that.showorNotParams = 'VideoTrial'
        that.plyrInstances.fullscreen.exit()
      }
      let refresh_html = document.querySelector('.plyr .video_trial_end >p') //重新试看
      refresh_html.onclick = function () {
        that.handleSelect(1)
        setTimeout(() => {
          that.playVideo()
        }, 300)
      }
    },
    /**
     * @description: 播放结束试看购买删除
     */
    videoTrialEndDel() {
      let video_trial_end_html = document.querySelector('.video_trial_end')
      if (video_trial_end_html) {
        let plyr_html = document.querySelector('.plyr')
        plyr_html.removeChild(video_trial_end_html)
      }
    },
    /**
     * @description: 学习签到
     */
    studySign(videoType) {
      if (!this.trainingInfo.enableSignIn) return
      if (videoType === 'playing') {
        const playbackRate = this.plyrInstances.media.playbackRate || 1
        this.studySignTimer = setInterval(() => {
          //实时获取视频倍速参数,如有变化,重新创建计时器
          const realPlaybackRate = this.plyrInstances.media.playbackRate || 1
          if (realPlaybackRate !== playbackRate) {
            clearInterval(this.studySignTimer)
            this.studySignTimer = null
            this.studySign('playing')
            return
          }
          //签到时间可配置
          if (this.studySignNum >= this.traningInfo.signInIntervalTime*60) {
            clearInterval(this.studySignTimer)
            this.plyrInstances.pause()
            this.studySignNum = 0
            this.studySignTimer = null
            if (this.plyrInstances.media.scrollWidth > 860) {
              this.plyrInstances.fullscreen.exit()
            }
            this.$alert('确认继续学习吗?', '温馨提示', {
              confirmButtonText: '确定',
              showClose: false,
              callback: action => {
                this.trainingSignIn()
                this.plyrInstances.play()
              }
            })
          } else {
            this.studySignNum++
          }
        }, 1000 / playbackRate)
      } else if (videoType === 'pause') {
        clearInterval(this.studySignTimer)
        this.studySignTimer = null
      }
    },
    /**
     * @description: 学习签到记录
     */
    trainingSignIn() {
      const params = {
        userId: this.userInfo.id,
        trainingId: this.$route.query.tId,
        projId: this.$route.query.pId,
        courseId: this.$route.query.cId
      }
      trainingSignIn(params)
    },
    /**
     * @description: 课程操作
     */
    handleCourse(type) {
      this.handleType = type
      // if (this.traningInfo.isBandCard === 0 && this.traningInfo.creditBingdingTerm === 5) {
      //   this.$message({
      //     message: `本课程可试看${ this.trainingInfo.tryWatchTime }分钟，购买后可观看完整内容`,
      //     type: 'warning',
      //     duration: 1500,
      //     onClose: () => {
      //       this.scoreBuyShopDialogShow = true
      //       this.showorNotParams = 'VideoTrial'
      //       this.pauseVideo() //暂停播放
      //     }
      //   })
      //   return
      // }
      // 是否开启人脸识别 并且 不存在人脸识别过标记
      const typeCode = type === 'toPractice' || type === 'dialogToPractice' ? 1: type=='openPdf'?3:'' // 1考试前
      // console.log(this.trainingInfo.faceRecognition.includes(typeCode), typeCode, this.trainingInfo.faceRecognition)
      if (this.trainingInfo.faceRecognition.includes(typeCode) && !sessionStorage.getItem(this.createFRSignKey())) {
        if(this.userInfo.inputType === 7){
          this.$refs.bindAccountTipDialog.isHandleAccountShow = true
          return
        }
        const params = {
          userId: this.userInfo.id,
          trainingId: this.$route.query.tId,
          projId: this.$route.query.pId,
          courseId: this.$route.query.cId
        }
        // 获取加密串
        getFaceSecretKey(params).then((res) => {
          const data = res.data
          if (data.code !== 0) {
            this.$message({
              type: 'error',
              message: data.msg
            })
            return
          }
          // 生成二维码并展示
          this.faceRecognitionQR = `YBS|${ data.data.secretKey }`
          this.faceRecognitionUuid = data.data.uuid
          this.faceRecognitionDialogVisible = true
        })
      } else {
        this.faceRecognitionUuid = ''
        this.pageJump()
      }
    },
    /**
     * @description: 查询是否已通过验证
     */
    isFaceVerification() {
      getFaceResult({uuid: this.faceRecognitionUuid}).then(res => {
        const data = res.data
        if (data.code !== 0) {
          this.$message({
            type: 'warning',
            message: data.msg
          })
          return
        }
        this.$message({
          type: 'success',
          message: data.msg
        })
        this.faceRecognitionDialogVisible = false
        // 存储人脸识别成功标记
        sessionStorage.setItem(this.createFRSignKey(), this.faceRecognitionUuid)
        setTimeout(() => {
          this.pageJump()
        }, 200)
      })
    },
    /**
     * @description: 页面跳转
     */
    pageJump() {
      switch (this.handleType) {
        case 'toPractice':
          this.toPractice()
          break
        case 'dialogToPractice':
          this.toWriteQuestion()
          break
        case 'openPdf':
          this.openPDF()
          break;
        default:
          break
      }
    },
    /**
     * @description: 生成人脸标记key
     */
    createFRSignKey() {
      const tId = this.$route.query.tId
      const pId = this.$route.query.pId
      const cId = this.$route.query.cId
      const sign = `${ process.env.VUE_APP_FRSIGN }${ this.userInfo.id }/${ tId }/${ pId }/${ cId }`
      return sign
    },
    /**
     * @description: 上传学习记录
     */
    saveWatchRecords() {
      // const uuid = this.$route.query.uuid
      // if (!uuid) return
      // const storageuuid = sessionStorage.getItem(uuid)
      // if (!storageuuid) {
      const params = {
        // batchId: uuid,
        userId: this.userInfo.id,
        trainingId: this.$route.query.tId,
        projId: this.$route.query.pId,
        courseId: this.$route.query.cId,
        type: 1
      }
      saveWatchRecords(params).then(res => {
        const data = res.data
        if (data.code !== 0) {
          this.plyrInstances.pause()
          this.$alert(data.msg, '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showClose: false,
            callback: action => {
              CloseWebPage()
            }
          })
          
        }
        // sessionStorage.setItem(uuid, uuid)
      }).catch(() => {
        if (this.retry > 0) {
          this.retry--
          setTimeout(() => {
            this.saveWatchRecords()
          }, 1000)
        }
      })
      // }
    },
    /**
     * @description: 判断是否 是在学习之前 是否绑卡
     */
    bangDingCard(traning) {
      //学习之前/未绑卡/非试看视频
      if (traning.creditBingdingTerm === 1 && traning.isBandCard === 0) {
        this.scoreBuyShopDialogShow = true
        this.showorNotParams = '暂未绑卡-链接查看'
      }
    },
    /**
     * @description: 根据培训班id获取培训班
     */
    getTrainingById() {
      return new Promise((resolve, reject) => {
        getTrainingById({
          //获得培训班信息
          id: this.$route.query.tId,
          // userId: this.$route.query.uId
          userId:  this.userInfo&&this.userInfo.id || this.$route.query.uId
        }).then((response) => {
          // console.log(response.data,'根据培训班id获取培训班')
          if (response.data.status !== 200) {
            resolve(response.data)
            return
          }
          this.trainingInfo = response.data.data.training
          if (this.trainingInfo.faceRecognition && this.trainingInfo.faceRecognition.length > 0) {
            if (typeof (this.trainingInfo.faceRecognition) == 'string') {
              this.trainingInfo.faceRecognition = this.trainingInfo.faceRecognition.split(',').map(parseFloat)
            }
          } else {
            this.trainingInfo.faceRecognition = []
          }
          let {data} = response
          if (data.data.training.businessType === 102) {
            this.isCme = true
          }
          if (this.trainingInfo.limitSingleDeviceLearning === 1) {
            VerifyDeviceBinding(this.trainingInfo.id, 40, this)
          }
          resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    /**
     * @description: /获得课件
     */
    getCourseWareByCourse() {
      getCourseWareByCourse({
        userId: this.userInfo ? this.userInfo.id : this.$route.query.uId,
        trainingId: this.$route.query.tId,
        projId: this.$route.query.pId,
        courseId: this.$route.query.cId
      }).then((response) => {
        this.courseVideoArr = response.data.data.courseVideoArr
        this.courseName = response.data.data.courseName
        document.title = '课程播放-' + this.courseName
        this.objective = response.data.data.objective
        this.teachInfo = response.data.data.teachInfo
        this.practiseSwitch = response.data.data.practiseSwitch
        this.handoutUrl = response.data.data.handoutInfo.url
          ? response.data.data.handoutInfo.url
          : ''
        this.courseFieldID = response.data.data.courseFieldID
        if (response.data.data.rateInfo.rateAvg) {
          this.rateValue = response.data.data.rateInfo.rateAvg
        }
        if (response.data.data.rateInfo.isUserRate) {
          this.isUserRate = response.data.data.rateInfo.isUserRate
          this.userRate = response.data.data.rateInfo.userRate
        }
        this.videoLoading = false
        
        if (!this.publicCourse) {
          // 获取视频记录
          this.getVideoRecords('first')
          /*查询课后练习*/
          queryCoursePracticesnew({
            trainingId: this.$route.query.tId,
            courseId: this.courseFieldID
          }).then(res=>{
              const { code, data, timestamp } = res.data
                this.practice = data||[]

          })
          // jsonp(
          //   process.env.VUE_APP_EXAM_API_URL +
          //   'course/practices/' +
          //   this.courseFieldID,
          //   (err, data) => {
          //     if (err) {
          //       return null
          //     } else {
          //       console.log('课后练习', data.data)
          //       this.practice = data.data
          //     }
          //   }
          // )
        } else {
          this.handleSelect(1,'first')
        }
      })
    },
    /**
     * @description: 视频播放
     */
    playVideo() {
      this.plyrInstances.play()
    },
    /**
     * @description: 视频暂停
     */
    pauseVideo() {
      this.plyrInstances.pause()
    },
    /**
     * @description: 完成达标去练习/考试
     */
    toWriteQuestion() {
      this.toWriteQuestionVisibleIsFirst = false
      this.toWriteQuestionVisible = false
      this.toPractice()
    },
    /**
     * @description: 视频锁定操作
     */
    postVideoCheckOnlineStudy(operate) {
      this.updWatchTimeVideoLock = this.watchTimeVideoLock
      if (
        this.watchTimeVideoLock > 0 &&
        this.$route.query.enableStudyOnTheSameTime == 1
      ) {
        postVideoCheckOnlineStudy({
          userId: this.$route.query.uId,
          trainingId: this.$route.query.tId,
          courseId: this.$route.query.cId,
          operate: operate,
          source: 'Web'
        }).then((res) => {
          if (res.data.code === -1) {
            this.$alert(
              '您正在其他浏览器播放学习本培训班课程，若要继续学习，请关闭或暂停其他课程。',
              '提示',
              {
                confirmButtonText: '确定',
                type: 'warning',
                showClose: false
              }
            )
            this.plyrInstances.pause()
          }
        })
        this.watchTimeVideoLock =
          this.watchTimeVideoLock > this.updWatchTimeVideoLock
            ? this.watchTimeVideoLock - this.updWatchTimeVideoLock
            : 0
      }
    },
    /**
     * @description: 视频切换是否允许拖拽,不允许拖拽则未观看的视频不允许切换,已经观看完的允许拖拽
    */
    handleDrag (key) { 
      if (key == this.defaultvideo){
         this.changeflag = true
        return
      } 
      return new Promise((resolve, reject)=>{
          getUserCoursePercentv2({
          trainingId: this.$route.query.tId,
          projId: this.$route.query.pId,
          courseId: this.$route.query.cId,
          uuid: this.userInfo.uuid
        }).then(res => {
          let courselistPercent = res.data.data
          //courselistPercent.coursewareList[key - 1].viewTime >= courselistPercent.coursewareList[key - 1].videoTotalTime
          if (courselistPercent.coursewareList[key - 1].viewTime > 0) {
            //观看时长大于等于视频总长度，允许拖拽
            this.changeflag = true
          } else {
            this.changeflag = false
             this.plyrInstances.pause()
          }
           resolve(res.data.data)
        }).catch(err =>{})
      })
  
     
    },
    /**
     * @description: 视频播放器初始化
     */
   async handleSelect(key,action) {
      // //判断是否允许拖拽，不允许拖拽则未观看的视频不允许切换
      if(action=='changevideo' && this.traningInfo.enableDragVideo == 0){
       await this.handleDrag(key)
        if(!this.changeflag){
          this.showtipdrag=true
          return
        }
      }
      this.loadedmetadataLock = true //设置可以获取视频进度接口
      if (this.defaultActive != key) {
        this.defaultActive = key
      }
      this.courseVideoArrId = this.courseVideoArr[key - 1].id
       this.courseVideoArrTotalTime = this.courseVideoArr[key - 1].videoTotalTime
      // if (this.onceenter) {
      //     //获取视频观看完成程度之后，调用一次上传视频记录接口，判断设备是否唯一
      //   this.syncWatchTimev2(1)
      // }
      
      this.isEnded = false
      this.plyrInstances.source = {
        type: 'video',
        title: this.courseVideoArr[key - 1].name,
        index: key - 1,
        sources: [
          {
            src: this.playModeValue
              ? this.courseVideoArr[key - 1].standardUrl
              : this.courseVideoArr[key - 1].ordinaryUrl,
            type: 'video/mp4'
          }
        ]
      }
      this.studySign('pause')
      this.tryVideo()
    },
    /**
     * @description: 初始化播放器监听事件
     */
    initPlayerEvents() {
      this.plyrInstances.on('ready', () => {
        //不允许拖拽增加拖拽监听事件
        if(this.traningInfo.enableDragVideo==0){
           this.videoProhibitDragging()
        }
        
      });
      //开始播放
      this.plyrInstances.on('playing', () => {
        //判断错误池是否超过3个,大于等于3停止播放
        if(this.watchTimeErrorList.length >= 3){
          this.plyrInstances.pause()
          this.$message.error('当前网络不佳')
          return
        }
         if(this.plyrInstances.media.currentTime==0){
          //初始播放禁止上传
          this.watchTime =0
         }
        if (this.disabledDrag){
         this.plyrInstances.pause()
        }
        this.studySign('playing')
        if (this.showAds === '1') {
          this.fullScreenDel()
        }
        if (!this.publicCourse && !this.setT) {
          // console.log('倍速切换playing')
          const time=Math.floor(1000/ this.plyrInstances.media.playbackRate)
          this.syncWatchTimev2(1)
          this.setT = setInterval(() => {
            this.watchTime += 1
          }, 1000)
        }
        if (!this.publicCourse && !this.setTVideo) {
          this.setTVideo = setInterval(() => {
            this.watchTimeVideo += 1
          }, 1000)
        }
        // if (!this.publicCourse && !this.setTVideoLock) {
        //   this.watchTimeVideoLock = 1
        //   this.postVideoCheckOnlineStudy(1) //视频加锁
        //   this.setTVideoLock = setInterval(() => {
        //     this.watchTimeVideoLock += 1
        //   }, 1000)
        // }
        if (this.seekTime != 0) {
          this.plyrInstances.seek(this.seekTime)
          this.seekTime = 0
        }
      })
    
      //暂停播放
      this.plyrInstances.on('pause', () => {
        this.studySign('pause')
        if (this.showAds === '1') {
          this.fullScreenAdd()
        }
        if (!this.publicCourse && this.setT&& !this.disablesave) {
            this.watchTime += 1
            this.syncWatchTimev2(2)
            this.setT = window.clearInterval(this.setT)
        }
        if (!this.publicCourse && this.setTVideo) {
          // this.saveVideoRecord()
          this.setTVideo = window.clearInterval(this.setTVideo)
        }
        if (!this.publicCourse && this.setTVideoLock) {
          // this.postVideoCheckOnlineStudy(2) //清除锁定
          this.setTVideoLock = window.clearInterval(this.setTVideoLock)
        }
      })
      // 倍速监听
      this.plyrInstances.on('ratechange', () => {
      
        if (this.watchTime > 0) {
        // console.log('倍速切换监听', this.watchTime)
        //倍速切换时存在掉时间问题，补偿1s时间
         this.watchTime += 1
          this.syncWatchTimev2(1)
          // this.setT = window.clearInterval(this.setT)
          // const time = Math.ceil(1000 / this.plyrInstances.media.playbackRate)
          // this.setT = setInterval(() => {
          //   // if(this.watchTime==0){
          //   //    this.watchTime= 1
          //   // }
          //   this.watchTime += 1
          // }, 1000)
        }
      })
      //播放进度监听
      this.plyrInstances.on('timeupdate', () => {
         if(this.trainingInfo.enableChangeSpeed == 0 && this.plyrInstances.media.playbackRate != 1) {
          this.hasShownSpeedWarning++
          this.plyrInstances.pause()
          if(this.hasShownSpeedWarning == 2) {
            this.$message.error('当前课程不允许倍速播放,请关闭倍速功能')
            this.hasShownSpeedWarning = 0
          }
          return
        }  

        const uId = this.$route.query.uId
        const tId = this.$route.query.tId
        const pId = this.$route.query.pId
        const cId = this.$route.query.cId
        //无tId为精品课
        if (this.plyrInstances.media.currentTime > 0 && !this.publicCourse) {
          sessionStorage.setItem(
            `${ uId }_${ tId }_${ pId }_${ cId }_${ this.courseVideoArrId }_currentTime`,
            this.plyrInstances.media.currentTime
          )
          sessionStorage.setItem(
            `${ uId }_${ tId }_${ pId }_${ cId }_${ this.courseVideoArrId }_duration`,
            this.plyrInstances.media.duration
          )
          //存储最大观看时长位置
          const maxtime= Number(sessionStorage.getItem( `${uId}_${tId}_${pId}_${cId}_${this.courseVideoArrId}_maxtime`))||0
          if(maxtime&& !this.disabledDrag){
            //禁止拖拽时，禁止更新最大时间
            const temp=this.plyrInstances.media.currentTime> maxtime? this.plyrInstances.media.currentTime: maxtime
            sessionStorage.setItem( `${uId}_${tId}_${pId}_${cId}_${this.courseVideoArrId}_maxtime`, temp)
          }else{
            sessionStorage.setItem(`${uId}_${tId}_${pId}_${cId}_${this.courseVideoArrId}_maxtime`,  this.plyrInstances.media.currentTime)
          }
          if (
            this.plyrInstances.media.duration -
            this.plyrInstances.media.currentTime <
            1
          ) {
            if (this.saveVideoRecordLock) {
              this.saveVideoRecordLock = false
              // this.saveVideoRecord()
            }
          }
          this.tryVideo()
        }
      })
      //自定义播放进度/loadedmetadata/canplaythrough
      this.plyrInstances.on('canplaythrough', () => {
        if (this.implementAutoProgress) return
        if (this.loadedmetadataLock && !this.publicCourse) {
          this.loadedmetadataLock = false
          getVideoRecords({
            userId: this.$route.query.uId,
            trainingId: this.$route.query.tId,
            projId: this.$route.query.pId,
            courseId: this.$route.query.cId,
            coursewareId: this.courseVideoArrId,
            isJiJiao: this.$route.query.isJiJiao, //是否继教
            myCourse:
              this.$route.query.switchMyProject === 'false' ? false : true
          })
            .then((res) => {
              this.implementAutoProgress = true
              if (res.data && res.data.data.length > 0) {
                if (res.data.data[0].totalTime - res.data.data[0].watchTime <= 2) {
                  this.plyrInstances.media.currentTime = res.data.data[0].watchTime - 2
                  this.$nextTick(() => {
                    this.plyrInstances.play()
                    setTimeout(() => {
                      this.plyrInstances.pause()
                    }, 300)
                  })
                } else {
                  this.plyrInstances.media.currentTime = res.data.data[0].watchTime
                  this.$nextTick(() => {
                    this.plyrInstances.play()
                    setTimeout(() => {
                      this.plyrInstances.pause()
                    }, 300)
                  })
                }
              }
            })
            .catch((error) => {
              this.loadedmetadataLock = true
            })
        }
      })
      this.plyrInstances.on('seeking', () => {
        if (this.traningInfo.enableDragVideo == 0) {
         const maxAllowedTime = this.getMTime().maxLocationTime
        //  console.log(this.plyrInstances.media.currentTime,'this.plyrInstances.media--')
        this.plyrInstances.pause()
          // setTimeout(() => {
            const media = this.plyrInstances.media;
            // console.log(media.currentTime, maxAllowedTime, '000000000')
            if (media.currentTime > maxAllowedTime) {
              this.plyrInstances.media.currentTime = maxAllowedTime
              if (this.plyrInstances.fullscreen.active) {
                this.plyrInstances.fullscreen.exit()
              }
              this.showtipdrag = true
              this.disabledDrag = true
            }
       }
        // }, 0);
      });
      //媒体被清空（初始化）时触发
      this.plyrInstances.on('emptied', () => {
        if (!this.publicCourse && this.setT) {
          this.syncWatchTimev2(2)
          this.setT = window.clearInterval(this.setT)
        }
        if (!this.publicCourse && this.setTVideo) {
          // this.saveVideoRecord()
          this.setTVideo = window.clearInterval(this.setTVideo)
        }
        if (!this.publicCourse && this.setTVideoLock) {
          // this.postVideoCheckOnlineStudy(2) //清除视频锁定
          this.setTVideoLock = window.clearInterval(this.setTVideoLock)
        }
      })
      this.plyrInstances.on('ended', () => {
        // console.log('ende')
        if (!util.isIE() || this.isEnded) {
          if (!this.publicCourse) {
            if (this.setT) {
              this.setT = window.clearInterval(this.setT)
            }
            let defaultActive = parseInt(this.defaultActive)
            if (this.palyerRecord.length > 0) {
              if (
                this.palyerRecord.indexOf(
                  this.courseVideoArr[defaultActive - 1].id
                ) == -1
              ) {
                this.palyerRecord.push(
                  this.courseVideoArr[defaultActive - 1].id
                )
                this.$storejs.set(
                  this.$route.query.uId +
                  '_' +
                  this.$route.query.tId +
                  '_' +
                  this.$route.query.pId +
                  '_' +
                  this.$route.query.cId,
                  this.palyerRecord
                )
              }
            } else {
              this.$storejs.set(
                this.$route.query.uId +
                '_' +
                this.$route.query.tId +
                '_' +
                this.$route.query.pId +
                '_' +
                this.$route.query.cId,
                [this.courseVideoArr[defaultActive - 1].id]
              )
              this.refreshPalyerRecord()
            }
          }
          
          if (!this.publicCourse && this.practiseSwitch == 1) {
            jsonp(
              process.env.VUE_APP_EXAM_API_URL +
              'course/practices/' +
              this.courseFieldID +
              '?' +
              'chapter=' +
              this.defaultActive,
              (err, data) => {
                if (err) {
                  return null
                } else {
                  if (data.data[0]) {
                    this.dialogVisible = true
                    this.practiseData = data.data[0]
                  } else {
                    this.switchNextPlayer()
                  }
                }
              }
            )
          } else {
            this.switchNextPlayer()
          }
        } else {
          this.isEnded = true
        }
      })
    },
    /**
     * @description: 保存视频播放进度 删掉
     */
    saveVideoRecord() {
      this.updWatchTimeVideo = this.watchTimeVideo
      if (this.watchTimeVideo > 0) {
        const uId = this.$route.query.uId
        const tId = this.$route.query.tId
        const pId = this.$route.query.pId
        const cId = this.$route.query.cId
        const isJiJiao = this.$route.query.isJiJiao
        const courseVideoArrId = this.courseVideoArrId
        let _duration = sessionStorage.getItem(
          `${ uId }_${ tId }_${ pId }_${ cId }_${ courseVideoArrId }_duration`
        )
        let _currentTime = sessionStorage.getItem(
          `${ uId }_${ tId }_${ pId }_${ cId }_${ courseVideoArrId }_currentTime`
        )
        if (_duration && _currentTime) {
          if (_duration - _currentTime < 1) {
            _currentTime = _currentTime - 2
          }
          saveVideoRecord({
            userId: uId,
            trainingId: tId,
            projId: pId,
            courseId: cId,
            coursewareId: courseVideoArrId,
            totalTime: parseInt(_duration),
            watchTime: parseInt(_currentTime),
            isJiJiao: isJiJiao, //是否继教
            myCourse:
              this.$route.query.switchMyProject === 'false' ? false : true
          }).then(() => {
            this.saveVideoRecordLock = true
            this.watchTimeVideo =
              this.watchTimeVideo > this.updWatchTimeVideo
                ? this.watchTimeVideo - this.updWatchTimeVideo
                : 0
          })
        }
      }
    },
    /**
     * @description: 获取所有视频进度信息
     */
    getVideoRecords(action) {
      getVideoRecords({
        userId: this.$route.query.uId,
        trainingId: this.$route.query.tId,
        projId: this.$route.query.pId,
        courseId: this.$route.query.cId,
        isJiJiao: this.$route.query.isJiJiao, //是否继教
        myCourse: this.$route.query.switchMyProject === 'false' ? false : true
      }).then((res) => {
        if (res.data.data.length > 0) {
          this.videoHistorylist = res.data.data
        } else {
          this.handleSelect(1, action)
        }
      }).catch(error =>{
        // console.log(JSON.stringify(error));
      })
    },
    /**
     * @description: 获取视频id所在视频列表的下标
     * @param {courseVideoArr,id} 视频列表,视频id
     * @return {number} 视频id所在列表中的下标
     */
    getVideoIndex(courseVideoArr, id) {
      for (var i in courseVideoArr) {
        if (courseVideoArr[i].id == id) {
          return Number(i)
        }
      }
    },
    /**
     * @description: 获取视频播放进度
     * @param {courseVideoArr,id} 视频列表,视频id
     */
    getVideoHistory(courseVideoArr, id) {
      //获取视频播放进度
      if (courseVideoArr && courseVideoArr.length > 0) {
        const videoId = this.getVideoIndex(courseVideoArr, id)
        this.defaultvideo= videoId+1
        if (videoId + 1) {
          this.handleSelect(videoId + 1, null)
        } else {
          this.handleSelect(1, null)
        }
      }
    },
    /**
     * @description: 获取视频id记录的时间
     * @param {videoHistoryArr,id} 视频列表,视频id
     * @return {} 视频id已观看的时间
     */
    getVideoHistoryTime(videoHistoryArr, id) {
      for (var i in videoHistoryArr) {
        if (videoHistoryArr[i].coursewareId == id) {
          return videoHistoryArr[i].watchTime
        }
      }
    },
    /**
     * @description: 视频上层广告添加
     */
    
    fullScreenAdd() {
      let that = this
      let plyr_html = document.querySelector('.plyr') //播放器窗口
      let imgSrc = 'https://source.yiboshi.com/banner-20200226.png'
      let html = `<div class="full_screen" style="opacity:0"><div class="advert_close"></div><img src="${ imgSrc }"/></div>`
      plyr_html.insertAdjacentHTML('beforeend', html)
      let advert_close_html = document.querySelector('.advert_close') //关闭按钮
      advert_close_html.onclick = function () {
        that.fullScreenDel()
      }
      
      //淡入
      function fadeIn() {
        let full_screen_html = document.querySelector('.full_screen')
        if (full_screen_html.style.opacity != 1) {
          let speed = 10
          let num = 0
          let st = setInterval(function () {
            num++
            full_screen_html.style.opacity = num / 10
            if (num >= 10) {
              clearInterval(st)
            }
          }, speed)
        }
      }
      
      fadeIn()
    },
    /**
     * @description: 视频上层广告删除
     */
    
    fullScreenDel() {
      let plyr_html = document.querySelector('.plyr')
      let full_screen_html = document.querySelector('.full_screen')
      
      //淡出
      function fadeOut() {
        if (full_screen_html && full_screen_html.style.opacity != 0) {
          let speed = 10
          let num = 10
          let st = setInterval(function () {
            num--
            full_screen_html.style.opacity = num / 10
            if (num <= 0) {
              clearInterval(st)
              plyr_html.removeChild(full_screen_html)
            }
          }, speed)
        }
      }
      
      fadeOut()
    },
    //获得课程视频观看完成度V2
    getUserCoursePercentV2 () {
      return new Promise((resolve, reject) => {
        getUserCoursePercentv2({
          trainingId: this.$route.query.tId,
          projId: this.$route.query.pId,
          courseId: this.$route.query.cId,
          uuid: this.userInfo.uuid
        }).then((response => {
          this.viewCourseTime = response.data.data.viewCourseTime
          this.courseCountTime = response.data.data.totalCourseTime
          this.percent = response.data.data.percent
           resolve(response.data.data)
        }))
      }).catch(err => {})
    },
    //获得课程视频观看完成度
    getUserCoursePercent() {
      getUserCoursePercent(
        this.userInfo ? this.userInfo.id : this.$route.query.uId,
        {
          trainingId: this.$route.query.tId,
          projectId: this.$route.query.pId,
          courseId: this.$route.query.cId
        }
      ).then((response) => {
        this.viewCourseTime = response.data.viewCourseTime
        this.courseCountTime = response.data.courseCountTime
        this.percent = response.data.percent
    
      })
    },
    switchNextPlayer() {
      let defaultActive = parseInt(this.defaultActive)
      if (defaultActive + 1 <= this.courseVideoArr.length) {
         this.defaultvideo = defaultActive + 1
        this.handleSelect((defaultActive + 1))
        this.plyrInstances.play()
      } else {
         this.defaultvideo = 1
        this.handleSelect(1)
      }
    },
    playModeChange(value) {
      this.playModeValue = value
      this.$storejs.set('playModeValue', value)
      this.seekTime = this.plyrInstances.currentTime
      if (this.setT) {
        window.clearInterval(this.setT)
      }
      this.handleSelect(this.defaultActive)
      this.plyrInstances.play()
    },
    rateChange(value) {
      if (this.userInfo) {
        if (!this.isUserRate) {
          saveCourseRate({
            //用户提交课程评星
            courseId: this.$route.query.cId,
            userId: this.userInfo.id || this.$route.query.uId,
            rate: value
          }).then((response) => {
            let {data} = response
            if (data.status === 200) {
              this.$message.success(data.msg)
              this.isUserRate = true
              this.userRate = value
              this.rateValue = value
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      } else {
        this.userRate = 0
        this.loginVisible = true
      }
    },
    toPractice() {
      this.plyrInstances.pause()
      window.open(`/usercenter/practice?courseId=${ this.$route.query.cId }&courseFieldID=${ this.courseFieldID }&trainingId=${ this.$route.query.tId }&projectId=${ this.$route.query.pId }&courseName=${ this.courseName }&parentPage=VideoPlayer&practiseSize=${ this.$route.query.practiseSize }`, 'practiceOnly')
    },
    openPDF() {
      if (this.traningInfo.isBandCard === 0 && this.traningInfo.creditBingdingTerm === 5) {
        this.$message({
          message: `本课程可试看${ this.trainingInfo.tryWatchTime }分钟，购买后可观看完整内容`,
          type: 'warning',
          duration: 1500,
          onClose: () => {
            this.scoreBuyShopDialogShow = true
            this.showorNotParams = 'VideoTrial'
            this.pauseVideo() //暂停播放
          }
        })
        return
      }
      this.plyrInstances.pause()
      window.open(
        '/handout' +
        '?uId=' +
        this.$route.query.uId +
        '&tId=' +
        this.$route.query.tId +
        '&pId=' +
        this.$route.query.pId +
        '&cId=' +
        this.$route.query.cId,
        'handout_blank'
      )
      window.open(
        `/handout?uId=${ this.$route.query.uId }&tId=${ this.$route.query.tId }&pId=${ this.$route.query.pId }&cId=${ this.$route.query.cId }&uuid=`,
        `handout_blank`
      )
    },
    submitAnswer() {
      if (this.practiseAns) {
        if (this.practiseAns == this.practiseData.ans) {
          this.$message.success('选择正确，请继续学习课程！')
          this.dialogVisible = false
          this.switchNextPlayer()
        } else {
          this.$message.error('错了哦，请重新作答！')
        }
      } else {
        this.$message.error('请选择正确的选项！')
      }
    },
    refreshPalyerRecord() {
      let palyerRecord = this.$storejs.get(
        this.$route.query.uId +
        '_' +
        this.$route.query.tId +
        '_' +
        this.$route.query.pId +
        '_' +
        this.$route.query.cId
      )
      if (palyerRecord) {
        this.palyerRecord = palyerRecord
      }
    },
    formatTime(s) {
      let t = '00:00'
      if (s > -1) {
        t = ''
        let min = Math.floor(s / 60)
        if (min < 10) {
          t += '0'
        }
        t += min + ':'
        let sec = s % 60
        if (sec < 10) {
          t += '0'
        }
        t += sec
      }
      return t
    },
    //上传本地上传错误的学习记录
    async saveRecordError (index){
        // console.log('x444', new Date().toLocaleString())
        // console.log(this.watchTimeErrorList,'前')
        const parms = JSON.parse(this.watchTimeErrorList[index])
         await syncCourseStatusV2(parms, this.uuid).then((response) => {
          //  this.watchTimeErrorList = this.watchTimeErrorList.filter(i => i != item)
            // console.log('哈哈2')
           this.watchTimeErrorList.splice(0,1)
            //  console.log(this.watchTimeErrorList, '后')
             if(this.watchTimeErrorList.length>0){
              this.saveRecordError(index)
             }
         }).catch(res => {
           this.errorflag += 1
          if(this.errorflag >= 3){
            this.$message.error('网络不佳,请稍后学习')
            this.plyrInstances.pause()
            this.setT = window.clearInterval(this.setT)
            }
         })
        //  console.log('哈哈')
    
      // for(const item of this.watchTimeErrorList){
      //   const parms=JSON.parse(item)
      //    syncCourseStatusV2(parms, this.uuid).then((response) => {
      //    this.watchTimeErrorList= this.watchTimeErrorList.filter(i => i!=item)
      //   //  console.log(this.watchTimeErrorList)
      //   }).catch(res => {
      //   })
      // }
   
    },
    //上传学习时间，更新视频位置，单设备判断，多页签，接口4合一
async syncWatchTimev2 (operate) {
      if (this.trainingEnd) return //培训班已结束
    
      if (this.trainingInfo.enableChangeSpeed == 0 && this.plyrInstances.media.playbackRate !=1) return //开启外挂倍速插件
      //判断视频上传记录方式：
      /*****
       * enableDragVideo:1-拖拽，dragIsCountTime：0-否统计时长;累计时长算法
       * enableDragVideo:1-拖拽，dragIsCountTime：1-统计时长;上传视频观看节点
       * enableDragVideo：0-否拖拽：上传视频观看节点
       * ****/
      // this.updWatchTime = Math.ceil(this.watchTime * this.oldplaybackRate)
 
      let parms={
          courseId: this.$route.query.cId,
          coursewareId: this.courseVideoArrId,
          projId: this.$route.query.pId,
          trainingId: this.$route.query.tId,
          operate: operate||1,
          uuid: this.userInfo.uuid
      }
        // 观看时间  
        const playbackRate=this.oldplaybackRate
        parms.upTime =Math.ceil(this.watchTime * playbackRate)
        console.log("this.watchTime",this.watchTime)
      //  console.log(playbackRate, '提交时倍速',)
      this.oldplaybackRate = this.plyrInstances.media.playbackRate || 1
        // parms.upTime = this.watchTime* playbackRate
        //观看当前位置时长
        const temp= Math.ceil(this.getMTime().currentLocationTime)
        parms.currentLocationTime = temp >Number(this.courseVideoArrTotalTime)? Number(this.courseVideoArrTotalTime):temp
        parms.maxLocationTime= Math.ceil(this.getMTime().maxLocationTime)

        //0不上传
        //if(parms.upTime<=0) return
        // console.log(parms,'parms')
      if (this.watchTime > 0) { //r判断提前
        //提交记录之前将观看时长清0，防止接口时间太长，观看时长清理不及时
        this.watchTime=0

        if(this.isUploadError){
          this.watchTimeErrorList.push(JSON.stringify(parms))
          return
        }
        // console.log(parms.upTime,'提交的记录时长')
        syncCourseStatusV2(parms,this.uuid).then(async (response) => {
          let { code, msg } = response.data
          //code = 100
          // this.onceenter=false
          if (code === 1) {
            this.$message.error(msg)
            this.watchTime = 0
            this.plyrInstances.pause()
            return false
          } else if (code === -1) {
            this.trainingEnd = true
            this.plyrInstances.pause()
            this.watchTime = 0
            this.$confirm('培训已结束!', '提示', {
              confirmButtonText: '确定',
              showClose: false,
              showCancelButton: false,
              type: 'warning'
            }).then(() => {
              CloseWebPage()
            }).catch(() => {
            })
          } else if (code === 0) {
            if (this.trainingInfo.enableDragVideo == 1 && this.trainingInfo.dragIsCountTime == 0) {
              //累计计算时长-进度逻辑
              // console.log('累计时长', parms.upTime)
              this.viewCourseTime += Math.ceil(parms.upTime)
              // this.watchTime = Math.ceil(this.watchTime * playbackRate) > this.updWatchTime ? Math.ceil(this.watchTime *
              //   playbackRate) - this.updWatchTime : 0
              this.watchTime=0
              this.percent = parseInt(Math.floor((this.viewCourseTime / this.courseCountTime) * 100)) > 100 ? 100 :
                parseInt(Math.floor((this.viewCourseTime / this.courseCountTime) * 100))
            } else {
              //只取当前最大观看时长，计算学习进度
              // const maxtime = Math.ceil(this.getMTime().maxLocationTime) 
              // this.percent = parseInt(Math.floor((maxtime / this.courseCountTime) * 100)) > 100 ? 100 :
              //   parseInt(Math.floor((maxtime / this.courseCountTime) * 100))
              // console.log('计算百分比', maxtime, this.courseCountTime)
              this.watchTime = 0
              await this.getUserCoursePercentV2()

            }
            //学习已达到要求,并且开启学习流程指导
            const noTipsTrainingId = ['1861', '1867']
            if (
              this.percent >= this.trainingInfo.electiveRatio &&
              this.practice.length > 0 &&
              this.trainingInfo.enableLearningFlowGuide==1&&
              this.toWriteQuestionVisibleIsFirst &&
              this.$route.query.isPractiseScore === 'yes' && this.practiseSwitch === 1
              && this.trainingId != '1710' && !noTipsTrainingId.includes(this.trainingId)
            ) {
              if (this.traningInfo.creditBingdingTerm === 5 && this.traningInfo.isBandCard === 0) {
                // 开启试看并且未购买
              } else {
                this.toWriteQuestionVisible = true
              }
            }
          } else if(code===2){
            this.watchTime = 0
            //验证设备是否唯一
            // VerifyDeviceBindingOpt(this.trainingInfo.id, response.data, this)
          } else if(code===3){
            // 视频锁定操作,既同一浏览器打开多个窗口，需要锁定窗口提示
            this.plyrInstances.pause()
            this.watchTime = 0
             this.$alert(
              msg,
              '提示',
              {
                confirmButtonText: '确定',
                type: 'warning',
                showClose: false
              }
            )
          //非法请求  
          } else if(code === 100){
             //当服务器发现最大位置不准确时,校准位置
             const uId = this.$route.query.uId
             const tId = this.$route.query.tId
             const pId = this.$route.query.pId
             const cId = this.$route.query.cId

             const res = await this.getUserCoursePercentV2()
             console.log("resres",res)
             const matchedItem = res.coursewareList.find(item => item.coursewareId === this.courseVideoArrId);
             const viewTime = matchedItem.viewTime
             if(this.plyrInstances.media.currentTime > viewTime) {
                 this.plyrInstances.media.currentTime = viewTime
             }
           console.log("viewTime",viewTime)
             sessionStorage.setItem(`${uId}_${tId}_${pId}_${cId}_${this.courseVideoArrId}_maxtime`,  viewTime)
          }
        }).catch(res=>{
           this.isUploadError = true
           this.watchTimeErrorList.push(JSON.stringify(parms))
           this.watchTime = 0
           this.errorflag += 1
          if(this.errorflag >=3){
            this.$message.error(res.msg||'服务异常')
            this.plyrInstances.pause()
            this.setT = window.clearInterval(this.setT)

          }
        })
      }
    },
    syncWatchTime() {
      if (this.trainingEnd) return //培训班已结束
      const playbackRate = this.plyrInstances.media.playbackRate || 1
      this.updWatchTime = Math.ceil(this.watchTime * playbackRate)
      if (this.watchTime > 0) {
        syncCourseStatus({
          //同步课程状态
          tId: this.$route.query.tId,
          pId: this.$route.query.pId,
          cId: this.$route.query.cId,
          upTime: Math.ceil(this.watchTime * playbackRate)
        }).then((response) => {
          const {status} = response.data
          if (status === 400) {
            this.$message.error('网络异常')
            return false
          } else if (status === 300) {
            this.trainingEnd = true
            this.plyrInstances.pause()
            this.$confirm('培训已结束!', '提示', {
              confirmButtonText: '确定',
              showClose: false,
              showCancelButton: false,
              type: 'warning'
            }).then(() => {
              CloseWebPage()
            }).catch(() => {
            })
          } else if (status === 200) {
            this.viewCourseTime += Math.ceil(this.watchTime * playbackRate)
            this.watchTime = Math.ceil(this.watchTime * playbackRate) > this.updWatchTime ? Math.ceil(this.watchTime * playbackRate) - this.updWatchTime : 0
            this.percent = parseInt( Math.floor((this.viewCourseTime / this.courseCountTime) * 100)) > 100 ? 100 : parseInt(Math.floor((this.viewCourseTime / this.courseCountTime) * 100))
            //学习已达到要求
            const noTipsTrainingId = ['1861', '1867']
            if (
              this.percent >= this.trainingInfo.electiveRatio &&
              this.practice.length > 0 &&
              this.toWriteQuestionVisibleIsFirst &&
              this.$route.query.isPractiseScore === 'yes' && this.practiseSwitch === 1
              && this.trainingId != '1710' && !noTipsTrainingId.includes(this.trainingId)
            ) {
              if (this.traningInfo.creditBingdingTerm === 5 && this.traningInfo.isBandCard === 0) {
                // 	开启试看并且未购买
              } else {
                this.toWriteQuestionVisible = true
              }
            }
          }
          // if (!response.data) {
          //   this.$message.error('网络异常')
          // } else {
          //   this.viewCourseTime += Math.ceil(this.watchTime * playbackRate)
          //   this.watchTime =
          //       Math.ceil(this.watchTime * playbackRate) > this.updWatchTime
          //           ? Math.ceil(this.watchTime * playbackRate) - this.updWatchTime
          //           : 0
          //   this.percent =
          //       parseInt(
          //           Math.floor((this.viewCourseTime / this.courseCountTime) * 100)
          //       ) > 100
          //           ? 100
          //           : parseInt(
          //               Math.floor(
          //                   (this.viewCourseTime / this.courseCountTime) * 100
          //               )
          //           )
          //   //学习已达到要求
          //   const noTipsTrainingId = ['1861', '1867']
          //   if (
          //       this.percent >= this.trainingInfo.electiveRatio &&
          //       this.practice.length > 0 &&
          //       this.toWriteQuestionVisibleIsFirst &&
          //       this.$route.query.isPractiseScore === 'yes' && this.practiseSwitch === 1
          //       && this.trainingId != '1710' && !noTipsTrainingId.includes(this.trainingId)
          //   ) {
          //     this.toWriteQuestionVisible = true
          //   }
          // }
        })
      }
    },
    showorNot(val) {
      // if (val == "暂未绑卡-链接查看") {
      // }
    },

  }
}
</script>
<style lang="less" scoped>
.video_main {
  .vm_video {
    /deep/ .plyr {
      position: absolute;
      
      .video_trial_playing {
        position: absolute;
        left: 25px;
        top: 25px;
        z-index: 999;
        background: rgba(0, 0, 0, 0.75);
        border-radius: 6px;
        padding: 6px 12px;
        
        > span {
          font-size: 14px;
          line-height: 24px;
          color: #FFFFFF;
          padding-right: 5px;
        }
        
        > a {
          font-size: 14px;
          line-height: 24px;
          color: rgba(255, 83, 0, 0.9);
          cursor: pointer;
          
          &:hover {
            color: rgba(255, 83, 0, 1);
          }
        }
      }
      
      .video_trial_end {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.75);
        z-index: 999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        
        > span {
          font-size: 16px;
          line-height: 50px;
          color: #FFFFFF;
        }
        
        > button {
          padding: 8px 30px;
          width: 134px;
          height: 36px;
          background: #0090FF;
          border-radius: 6px;
          border: 0 none;
          color: #FFFFFF;
          font-size: 16px;
          line-height: 20px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          
          > img {
            height: 20px;
            margin-right: 6px;
          }
        }
        
        > p {
          font-size: 14px;
          margin: 21px 0 0;
          line-height: 20px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          
          > img {
            height: 20px;
            margin-right: 6px;
          }
          
        }
      }
    }
  }
  .floating-account {
            position: fixed;
            bottom: 250px;
            right: 300px;
            width: 50px;
            height: 50px;
            background: #ff4040;
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            cursor: pointer;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
            z-index: 1000;
            cursor: pointer;
            opacity: 0.6;

            &:hover {
                opacity: 1;
                transition: all 0.3s ease;

                i {
                    opacity: 1;
                }
            }
  }
  .floating-component{
      position: fixed;
      bottom: 160px;
      right: 330px;
      z-index: 1000;
 
  }
}
</style>
<style>
.full_screen {
  position: absolute;
  z-index: 9999;
  top: 50%;
  left: 50%;
  width: 450px;
  height: 280px;
  transform: translate(-50%, -50%);
  border: 0px solid rgba(9, 4, 5, 1);
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 1);
}

.full_screen .advert_close {
  font-weight: 600;
  position: absolute;
  z-index: 999999;
  top: 5px;
  right: 5px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  opacity: 0.5;
  border-radius: 50%;
  background: url("../assets/images/gg_close.png") no-repeat;
  background-size: 100% 100%;
}

.full_screen .advert_close:hover {
  transform: scale(1.1, 1.1);
  opacity: 0.7;
}

.full_screen img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  object-fit: cover;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
legend,
input,
textarea,
p,
th,
td {
  margin: 0;
  padding: 0;
}

.clear {
  font-size: 0;
  line-height: 0;
  display: block;
  clear: both;
  overflow: hidden;
  height: 0;
}

li {
  list-style: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
}

a,
a:link,
a:visited {
  text-decoration: none;
  color: #333333;
}

a:hover {
  text-decoration: none;
  color: #FF5300;
}

body a img {
  border: 0px;
}

body {
  font-size: 14px;
  color: #333333;
}

.video_top {
  width: 100%;
  min-width: 980px;
  height: 100px;
  background: #ffffff;
}

.vt {
  height: 90px;
  margin: 0px auto;
}

.vt_logo {
  float: left;
  width: 365px;
  height: 70px;
  margin-top: 14px;
}

.vt_logo a img {
  width: 365px;
  height: 70px;
}

.vt_nav {
  float: right;
  width: 801px;
  padding-top: 20px;
}

.vt_nav a {
  font-size: 18px;
  line-height: 50px;
  position: relative;
  display: block;
  float: right;
  width: 180px;
  height: 50px;
  margin-left: 20px;
  padding-left: 50px;
  text-align: center;
  color: #FFFFFF;
  border-radius: 6px;
}

.vt_nav a span {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 50px;
  height: 50px;
  -moz-transition: background 0.2s ease;
  -o-transition: background 0.2s ease;
  -webkit-transition: background 0.2s ease;
  transition: background 0.2s ease;
  border-radius: 6px 0px 0px 6px;
  background-image: url(../assets/img-4/video-player/coursevideo_title.png);
  background-repeat: no-repeat;
}

a.vtn_wyks {
  background: #BB6054;
}

a.vtn_wyks > span {
  background-position: left -150px;
}

a.vtn_wyks:hover > span {
  background-position: -50px -150px;
}

a.vtn_jy {
  background: #4EBF92;
}

a.vtn_jy > span {
  background-position: left -100px;
}

a.vtn_jy:hover > span {
  background-position: -50px -100px;
}

a.vtn_xxmb {
  background: #C9A336;
}

a.vtn_xxmb > span {
  background-position: left -50px;
}

a.vtn_xxmb:hover > span {
  background-position: -50px -50px;
}

a.vtn_lsjj {
  background: #2292D4;
}

a.vtn_lsjj > span {
  background-position: left 0px;
}

a.vtn_lsjj:hover > span {
  background-position: -50px 0px;
}

.video_main {
  width: 100%;
  padding-top: 20px;
  background: #26262B;
}

.vm {
  position: relative;
  margin: 0px auto;
  padding-right: 320px;
}

/*右侧目录*/
.vm_list {
  position: absolute;
  top: 0;
  right: 0;
  width: 320px;
  background: #4C4C4D;
}

.vml_title {
  font-size: 18px;
  line-height: 50px;
  overflow: hidden;
  height: 50px;
  padding: 0px 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #C1C1C1;
}

.vml_main {
  overflow-y: auto;
  padding: 0px 15px;
  padding-top: 10px;
}

.vml_main ul {
}

.vml_main ul li {
  position: relative;
  height: 60px;
  margin-bottom: 15px;
  padding-left: 114px;
  cursor: pointer;
}

.vml_main ul li span {
  position: absolute;
  top: 0px;
  left: 0px;
  display: block;
  width: 104px;
  height: 60px;
  padding: 2px;
}

.vml_main ul li span p {
  font-size: 12px;
  line-height: 20px;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 42px;
  height: 20px;
  text-align: center;
  white-space: nowrap;
  color: #FFFFFF;
  border-radius: 5px 0px 0px 0px;
  background: rgba(0, 0, 0, 0.6);
}

.vml_main ul li a {
  font-size: 14px;
  line-height: 24px;
  display: block;
  overflow: hidden;
  height: 54px;
  padding-top: 6px;
  padding-right: 6px;
  color: #CCCCCC;
}

img.video_over {
  position: absolute;
  z-index: 9;
  top: -7px;
  left: 68px;
}

.vml_main ul li:hover {
  background: #616161;
}

.vml_main ul li.vmlm_ing {
  background: #616161;
}

.vml_main ul li.vmlm_ing span {
  background: #6CB517;
}

.vml_main ul li.vmlm_ing a {
  color: #6CB517;
}

.vml_main::-webkit-scrollbar {
  width: 8px;
}

.vml_main::-webkit-scrollbar-track {
  -moz-border-radius: 2em;
  -webkit-border-radius: 2em;
  border-radius: 2em;
  background-color: #888888;
}

.vml_main::-webkit-scrollbar-thumb {
  -moz-border-radius: 2em;
  -webkit-border-radius: 2em;
  border-radius: 2em;
  background-color: #DDDDDD;
}

.vm_star {
  position: relative;
  height: 46px;
  padding: 0px 130px 0px 250px;
}

.vm_star span.vms_title {
  font-size: 18px;
  line-height: 46px;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100px;
  height: 46px;
  color: #FFFFFF;
}

/*.video_dabiao {
        width: 100%;
        color: #ff0000;
        line-height: 44px;
        text-align: center;
    }*/

.video_dabiao {
  font-size: 16px;
  font-weight: bold;
  line-height: 44px;
  width: 100%;
  text-align: center;
  color: #FF5207;
}

.vm_star .vms_pf {
  position: absolute;
  top: 13px;
  left: 90px;
}

.vm_qingxi {
  position: absolute;
  top: 0px;
  right: 5px;
  width: 130px;
  height: 40px;
  padding-top: 10px;
}

/*根据浏览器宽度判断页面宽度*/
@media screen and (max-width: 1180px) {
  .vt {
    width: 980px;
  }
  
  .vm {
    width: 980px;
    height: 420px;
  }
  
  .vm_video {
    position: relative;
    width: 100%;
    height: 371px;
  }
  
  .vm_video .advertisement {
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    overflow: hidden;
    width: 30%;
    height: 30%;
    background-color: yellow;
  }
  
  .vml_main {
    height: 321px;
  }
  
  .video_comment {
    width: 980px;
  }
  
  .vt_nav a {
    margin-left: 10px;
  }
  
  .vt_nav {
    width: 761px;
  }
}

@media screen and (min-width: 1181px) and (max-width: 1680px) {
  .vt {
    width: 1180px;
  }
  
  .vm {
    width: 1180px;
    height: 531px;
  }
  
  .vm_video {
    position: relative;
    width: 100%;
    height: 484px;
  }
  
  .vm_video .advertisement {
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    overflow: hidden;
    width: 30%;
    height: 30%;
    background-color: red;
  }
  
  .vml_main {
    height: 434px;
  }
  
  .video_comment {
    width: 1180px;
  }
}

@media screen and (min-width: 1681px) {
  .vt {
    width: 1360px;
  }
  
  .vm {
    width: 1360px;
    height: 633px;
  }
  
  .vm_video {
    position: relative;
    width: 100%;
    height: 585px;
  }
  
  .vm_video .advertisement {
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    overflow: hidden;
    width: 30%;
    height: 30%;
    background-color: red;
  }
  
  .vml_main {
    height: 535px;
  }
  
  .video_comment {
    width: 1360px;
  }
}

.mt_main {
  position: relative;
  overflow: hidden;
  min-height: 185px;
}

.pl165 {
  padding-left: 165px;
}

.mtm_left {
  position: absolute;
  top: 0;
  left: 0;
  width: 150px;
  height: 185px;
}

.mtm_right {
}

.mtm_right p:nth-child(1) {
  font-size: 16px;
  line-height: 30px;
}

.mtm_right p:nth-child(2) {
  font-size: 14px;
  line-height: 22px;
}

</style>





// WEBPACK FOOTER //
// src/views/VideoPlayer.vue